import { AppBar, Box, Toolbar } from '@mui/material'
import { useHistory } from 'react-router-dom'

export default function Header({ isHeaderTitleOnly = true, position = 'static' }) {
  const history = useHistory()

  const handleTitleClick = () => {
    if (!isHeaderTitleOnly) {
      history.push('/tra-cuu-phat-nguoi')
    }
  }

  return (
    <AppBar
      position={position}
      sx={{
        bgcolor: '#262fed',
        width: '100%',
        py: 0
      }}>
      <Toolbar
        variant='dense'
        sx={{
          minHeight: '50px !important',
          height: '50px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <Box
            onClick={handleTitleClick}
            sx={{
              color: 'white',
              fontWeight: 'bold',
              fontSize: { xs: '0.95rem', sm: '1.1rem' },
              cursor: isHeaderTitleOnly ? 'default' : 'pointer'
            }}>
            Tra cứu phạt nguội
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  )
}